import Vue from 'vue'

const ENABLE  = 'ENABLE'
const DISABLE = 'DISABLE'
const DELAY_TIME = 10000

const state = {
  isActive: false,
  content: '',
  type: 'info'
}

let delayHideMessage;

export const mutations = {
  [ENABLE] (state, message) {
    state.isActive = true
    state.content = message.content
    state.type = message.type
  },
  [DISABLE] (state) {
    state.isActive = false
    state.content = ''
    state.type = ''
  }
}

export const actions = {
  enable({ commit }, message) {
    commit(ENABLE, message)
    $( ".page-container" ).scrollTop( 0 );
    clearTimeout(delayHideMessage);
    delayHideMessage = setTimeout(() => {
      commit(DISABLE);
    }, DELAY_TIME);
  },

  disable({ commit }) {
    commit(DISABLE)
  }
}

export const getters = {
  content: state => state.content,
  isActive: state => state.isActive,
  type: state => state.type
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/common/message.js